import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';

import { RpcService } from '../../shared/http/rpc.service';
import { PaymentAccountDTO } from './dto/payment-account.dto';
import { PaymentAccount } from './model/payment-account';
import { EstablishmentService } from 'app/shared/establishment/establishment.service';

@Injectable()
export class PaymentAccountService implements OnDestroy {
  private establishmentChangedSubscription: Subscription;
  private paymentAccount$: Observable<PaymentAccount>;
  private paymentAccountChangedSubject: BehaviorSubject<
    PaymentAccount
  > = new BehaviorSubject(null);

  constructor(
    private rpc: RpcService,
    private establishmentService: EstablishmentService
  ) {
    this.establishmentChangedSubscription = this.establishmentService.establishmentChanged$.subscribe(
      () => this.resetPaymentAccount()
    );
  }

  public ngOnDestroy(): void {
    if (this.establishmentChangedSubscription) {
      this.establishmentChangedSubscription.unsubscribe();
    }
  }

  public getPaymentAccount(): Observable<PaymentAccount> {
    if (!this.paymentAccount$) {
      this.paymentAccount$ = this.rpc.makeManagerCall('getPaymentAccount').pipe(
        map((result: PaymentAccountDTO) => {
          this.paymentAccountChangedSubject.next(
            PaymentAccount.convertFromDTO(result)
          );
          return PaymentAccount.convertFromDTO(result);
        }),
        catchError(() => {
          this.paymentAccountChangedSubject.next(
            PaymentAccount.convertFromDTO(null)
          );
          return [PaymentAccount.convertFromDTO(null)];
        }),
        publishReplay(1),
        refCount()
      );
    }
    return this.paymentAccount$;
  }

  public resetPaymentAccount(): void {
    this.paymentAccount$ = null;
    this.paymentAccountChangedSubject.next(null);
    this.getPaymentAccount();
  }

  public get paymentAccountChanged(): Observable<PaymentAccount> {
    return this.paymentAccountChangedSubject.asObservable();
  }
}
